import React from 'react';

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name[0].toUpperCase();
};

const colorFromName = (name) => {
  if (!name) return '#007AFF';
  const colors = ['#007AFF', '#FF9500', '#34C759', '#FF3B30', '#AF52DE', '#5856D6', '#FF2D55', '#00C7BE'];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
};

const UserAvatar = ({ src, name, size = 32, className = '' }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        className={`rounded-full object-cover flex-shrink-0 ${className}`}
        style={{ width: size, height: size }}
        data-testid="user-avatar-img"
      />
    );
  }

  return (
    <div
      className={`rounded-full flex items-center justify-center flex-shrink-0 font-bold text-white ${className}`}
      style={{ width: size, height: size, backgroundColor: colorFromName(name), fontSize: size * 0.4 }}
      data-testid="user-avatar-initials"
    >
      {getInitials(name)}
    </div>
  );
};

export default UserAvatar;
